import React from "react";

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const TopItemsTableLoading = () => {
    return (
        <div className="bg-white rounded-4 shadow-sm text-center">
            <h5 className="pt-3" style={{ color: "var(--theme-btn-color, #4318FF)" }}>
                Top Performing Items
            </h5>
            <ul className="nav nav-tabs mb-3 mt-2">
                <li className="nav-item">
                    <button
                        className={`nav-link`}
                    >
                       
                        Month to Date
                    </button>
                </li>
                <li className="nav-item">
                    <button
                        className={`nav-link`}
                    >
                      Financial Year
                    </button>
                </li>
            </ul>
            <table className={`table mt-2 rounded py-2`}>
                <thead>
                    <tr style={{ borderTopLeftRadius: "20px" }}>
                        {/* <th>#</th> */}
                        <th style={{ borderTopLeftRadius: "15px" }}>Name</th>
                        <th>Sold Quantity</th>
                    </tr>
                </thead>
                <tbody>
                    {/* {(isLoading || list.length === 0) && (
            <tr>
              <td colSpan="7" className="text-center">
                {isLoading ? "Loading..." : "No Records"}
              </td>
            </tr>
          )} */}
                    {/* {list.map((v, i) => (
            <> */}
                    <tr>
                        {/* <td>{currentPage * 10 - 10 + i + 1}</td> */}
                        <td>
                            <Skeleton />
                        </td>
                       
                        <td>
                            <Skeleton />
                        </td>
                    </tr>
                    <tr>
                        {/* <td>{currentPage * 10 - 10 + i + 1}</td> */}
                        <td>
                            <Skeleton />
                        </td>
                        
                        <td>
                            <Skeleton />
                        </td>
                    </tr>
                    <tr>
                        {/* <td>{currentPage * 10 - 10 + i + 1}</td> */}
                        <td>
                            <Skeleton />
                        </td>
                       
                        <td>
                            <Skeleton />
                        </td>
                    </tr>
                    <tr>
                        {/* <td>{currentPage * 10 - 10 + i + 1}</td> */}
                        <td>
                            <Skeleton />
                        </td>
                       
                        <td>
                            <Skeleton />
                        </td>
                    </tr>
                    <tr>
                        {/* <td>{currentPage * 10 - 10 + i + 1}</td> */}
                        <td>
                            <Skeleton />
                        </td>
                       
                        <td>
                            <Skeleton />
                        </td>
                    </tr>
                    <tr>
                        {/* <td>{currentPage * 10 - 10 + i + 1}</td> */}
                        <td>
                            <Skeleton />
                        </td>
                        
                        <td>
                            <Skeleton />
                        </td>
                    </tr>
                    <tr>
                        {/* <td>{currentPage * 10 - 10 + i + 1}</td> */}
                        <td>
                            <Skeleton />
                        </td>
                        
                        <td>
                            <Skeleton />
                        </td>
                    </tr>
                    <tr>
                        {/* <td>{currentPage * 10 - 10 + i + 1}</td> */}
                        <td>
                            <Skeleton />
                        </td>
                        
                        <td>
                            <Skeleton />
                        </td>
                    </tr>
                    <tr>
                        {/* <td>{currentPage * 10 - 10 + i + 1}</td> */}
                        <td>
                            <Skeleton />
                        </td>
                        
                        <td>
                            <Skeleton />
                        </td>
                    </tr>
                    <tr>
                        {/* <td>{currentPage * 10 - 10 + i + 1}</td> */}
                        <td>
                            <Skeleton />
                        </td>
                        
                        <td>
                            <Skeleton />
                        </td>
                    </tr>
                    {/* </>
          ))} */}
                </tbody>
            </table>
        </div>
    );
};

export default TopItemsTableLoading;
